module.exports = __webpack_public_path__ + "img/bg-proyectos-6.dced09a0.png";